import { LanguageIsoCodeEnumSchema } from "@iot-platform/core";
import { UserRoleEnumSchema } from "@user/domain/models/user-role.model";
import * as z from "zod";

export const AuthenticatedUserSchema = z
    .object({
        id: z.int().positive(),
        name: z.string().trim().nullable(),
        email: z.string().trim(),
        rol: UserRoleEnumSchema.nullable(),
        language: LanguageIsoCodeEnumSchema.optional(),
        timeZone: z.string().trim(),
    })
    .readonly();

export type AuthenticatedUserInputProps = z.input<
    typeof AuthenticatedUserSchema
>;
export type AuthenticatedUser = z.output<typeof AuthenticatedUserSchema>;
